import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./AllNGOPrivateScholarship.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AllNGOPrivateScholarship = () => {
  const [ngoPrivateScholarship, setNgoPrivateScholarship] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    fetchScholarships();
  }, []);

  const fetchScholarships = () => {
    axios
      .get(`${API_BASE_URL}/scholarships?type=NGO/Private`)
      .then((response) => {
        setNgoPrivateScholarship(response.data);
      })
      .catch((error) => console.log(error));
  };

  const handleEdit = (id) => {
    navigate(`/student-scholarship/edit-private-scholarship/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this scholarship?")) {
      axios
        .delete(`${API_BASE_URL}/scholarships/${id}`)
        .then(() => {
          alert("Scholarship deleted successfully.");
          fetchScholarships();
        })
        .catch((error) => {
          console.error("Failed to delete the scholarship:", error);
          alert("An error occurred while deleting the scholarship.");
        });
    }
  };
  return (
    <>
      <div id="all-private-scholarship-all-main">
        <div className="all-private-gov-heading-main-div">
          <h4>NGO/Private Scholarship Table</h4>
          <div className="header-main-btns">
            <button
              onClick={() =>
                navigate("/student-scholarship/private-scholarship")
              }
            >
              NGO/Private Scholarship
            </button>
            <button>All NGO/Private Scholarship</button>
          </div>
        </div>
        <div className="form-sub-container mt-4" id="form">
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Title</th>
                <th>Description</th>
                <th>YouTube Link</th>
                <th>Other Link</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {ngoPrivateScholarship &&
                ngoPrivateScholarship.map((item, idx) => (
                  <tr key={item._id}>
                    <td>{idx + 1}</td>
                    <td>{item.title}</td>
                    <td>{item.description.slice(0, 50)}...</td>
                    <td>{item.youtubeLink}</td>
                    <td>{item.officialLink}</td>
                    <td>
                      <span>
                        <FaEdit onClick={() => handleEdit(item._id)} />
                      </span>
                      <span>
                        <MdDelete onClick={() => handleDelete(item._id)} />
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllNGOPrivateScholarship;
